<div class="input-group">
  <input
    type="text"
    [id]="id"
    [placeholder]="placeholder"
    [class]="inputClass"
    [class.is-invalid]="hasError"
    [readonly]="readonly"
    [disabled]="disabled"
    [ngModel]="displayValue"
    [ngModelOptions]="{ standalone: true }"
    mask="d0/M0/0000"
    [dropSpecialCharacters]="false"
    (ngModelChange)="onTextInput($event)"
    (blur)="onBlur()"
  />
  <button
    type="button"
    class="btn border calendar-btn"
    [disabled]="disabled || readonly"
    (click)="openPicker()"
    aria-label="Seleccionar fecha"
  >
    <app-icon name="calendar" [size]="18" [strokeWidth]="2"></app-icon>
  </button>
</div>

@if (showErrorMessage) {
<div class="invalid-feedback d-block">{{ currentErrorMessage }}</div>
}

<input
  #nativeDateInput
  type="date"
  class="native-picker-input"
  [value]="nativePickerValue"
  [attr.max]="maxDate"
  [attr.min]="minDate"
  [disabled]="disabled || readonly"
  (change)="onNativeDateChangeEvent($event)"
/>
